import type { FC, PropsWithChildren } from 'react';

import { useModifiers } from '../../styles/hooks/useModifiers';

import styles from './Ribbon.module.css';

interface RibbonProps extends PropsWithChildren {
  label: string;
  scrollable?: boolean;
  onewayFade?: boolean;
}

export const Ribbon: FC<RibbonProps> = ({ label, children, scrollable, onewayFade }) => {
  const mods = useModifiers(styles, 'ribbon', { scrollable, onewayFade }, { withBaseClass: true });
  return (
    <div data-testid="ribbon" className={mods}>
      <div data-testid="ribbon-label" className={styles.ribbon__label}>
        {label}
      </div>
      <div data-testid="ribbon-message" className={styles.ribbon__message}>
        {children}
      </div>
    </div>
  );
};
